/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable no-undef */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */

import React, { useEffect, useState } from "react";
import axios from "axios";
import Charts from "./charts";
import Reports from "./Reports";
import Statistics from "./statistics";
import InvoiceTable from "./invoiceTable";
import PaymentTable from "./paymentTable";
import ClientTable from "./clientTable";
import RecentTable from "./recentTable";
import Breadcrumbs from "../../../../../components/Breadcrumbs";
import { base_url } from "../../../../../base_urls";
import { useTranslation } from "react-i18next";

import { Link, useParams, useNavigate } from "react-router-dom";

import {
  Applogo,
  Avatar_02,
  headerlogo,
  lnEnglish,
  lnAngola,
  lnFrench,
  lnGerman,
  lnSpanish,
} from "../../../../../Routes/ImagePath";
import MapChart from "./MapChart";

import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

import { format } from "date-fns";

import Swal from "sweetalert2";

import AuthUser from "../../../../../components/AuthUser";
import { toast, ToastContainer } from "react-toastify";
import Spinner from "../../../../../components/Spinner";
import { Projection } from "leaflet";
import TodasTarefasModalPopup from "../../../../../components/modelpopup/TodasTarefasModalPopup";

const AdminDashboard = () => {
  const [users, setUsers] = useState([]);

  const navigate = useNavigate();

  // eslint-disable-next-line no-unused-vars
  const {
    http,
    url_root,
    user_permissoes,
    verificarPermissao,
    getToken,
    user,
    getMissao,
  } = AuthUser();

  const [dashboard_info, setDashboardInfo] = useState({});
  const [filteredActividades, setFilteredActivities] = useState([]);

  const [totalColaboradores, setTotalColaboradores] = useState(0);
  const [totalHomens, setTotalHomens] = useState(0);
  const [totalMulheres, setTotalMulheres] = useState(0);
  const [totalExpatriados, setTotalExpatriados] = useState(0);
  const [atividadesRecentes, setAtividadesRecentes] = useState([]);
  const [admissoesPorDia, setAdmissoesPorDia] = useState([]);
  const [ultimasAdmissoes, setUltimasAdmissoes] = useState([]);
  const [feriasMensal, setFeriasMensal] = useState([]);

  // State to track whether the "checkgeral" checkbox is checked
  const [loading, setLoading] = useState(false);

  const [flagImage, setFlagImage] = useState(lnAngola);

  const { t, i18n } = useTranslation();

  const [totalsByMonth, setTotalsByMonth] = useState({});

  //const totalsByMonth = {};

  const changeLanguage = (lng) => {
    console.log(`Changing language to ${lng}`);
    i18n.changeLanguage(lng).then(() => {
      console.log(`Language changed successfully to ${lng}`);
    });

    // Debugging statement
    i18n.changeLanguage(lng);
    setFlagImage(
      lng == "en"
        ? lnEnglish
        : lng == "fr"
        ? lnFrench
        : lng == "es"
        ? lnSpanish
        : lng == "pt"
        ? lnAngola
        : lnGerman
    );
  };

  // eslint-disable-next-line
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        await getDashboardInfo();
      } catch (error) {
        console.error("Erro ao obter dados do dashboard:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const formatarFeriasMensal = (ferias) => {
    const meses = [
      "",
      "Jan",
      "Fev",
      "Mar",
      "Abr",
      "Mai",
      "Jun",
      "Jul",
      "Ago",
      "Set",
      "Out",
      "Nov",
      "Dez",
    ];

    return ferias.map((f) => ({
      mes: meses[f.mes], // f.mes é número de 1 a 12
      total: f.total,
    }));
  };

  const getDashboardInfo = async () => {
    try {
      setLoading(true);

      const res = await http.get("/dashboard/rh/" + getMissao().id); // endpoint atualizado

      const data = res.data;

      setTotalColaboradores(data.colaboradores_qtd);
      setTotalHomens(data.homens_qtd);
      setTotalMulheres(data.mulheres_qtd);
      setTotalExpatriados(data.expatriados_qtd);
      setAtividadesRecentes(data.atividades_recentes || []);
      setAdmissoesPorDia(data.admissoes_por_dia || []);
      setUltimasAdmissoes(data.ultimas_admissoes || []);

      setFeriasMensal(formatarFeriasMensal(data.ferias_mensal || []));

      console.log("Dashboard RH", data);
    } finally {
      setLoading(false);
    }
  };

  const handleNavegarParaTarefa = (tarefa_id) => {
    navigate("/task/tasks/" + tarefa_id);
  };

  // Verifique se dashboard_info.tickets é um array antes de aplicar métodos de array
  const tickets = Array.isArray(dashboard_info?.tickets)
    ? dashboard_info?.tickets
    : [];

  if (loading)
    return (
      <>
        <Spinner></Spinner>
      </>
    );
  else
    return (
      <div className="main-wrapper">
        <div className="page-wrapper">
          <div className="content container-fluid">
            {/* Page Header */}
            <Breadcrumbs
              maintitle={t("Welcome") + ", " + user?.name}
              title="Dashboard"
            />
            {/* /Page Header */}
            <div className="row">
              <div className="col-md-6 col-sm-6 col-lg-6 col-xl-3">
                <div className="card dash-widget">
                  <div className="card-body">
                    <span className={`dash-widget-icon fa fa-cubes`} />
                    <div className="dash-widget-info">
                      <h3>{totalColaboradores}</h3>
                      <span>{t("Total colaboradores")}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-sm-6 col-lg-6 col-xl-3">
                <div className="card dash-widget">
                  <div className="card-body">
                    <span className={`dash-widget-icon fa fa-ticket`} />
                    <div className="dash-widget-info">
                      <h3>{totalMulheres}</h3>
                      <span>{t("Mulheres")}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-sm-6 col-lg-6 col-xl-3">
                <div className="card dash-widget">
                  <div className="card-body">
                    <span className={`dash-widget-icon fa fa-list`} />
                    <div className="dash-widget-info">
                      <h3>{totalHomens}</h3>
                      <span>{t("Homens")}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-sm-6 col-lg-6 col-xl-3">
                <div className="card dash-widget">
                  <div className="card-body">
                    <span className={`dash-widget-icon fa fa-user`} />
                    <div className="dash-widget-info">
                      <h3>{totalExpatriados}</h3>
                      <span>{t("Expatriados")}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* /Charts */}

            <Charts
              atividades={atividadesRecentes}
              projetos={admissoesPorDia}
              tickets={[]}
            />

            {/* /Charts */}

            <div className="row">
              <div className="col-md-12">
                <div className="row">
                  <div className="col-md-12 text-center">
                    <div className="card">
                      <div className="card-body">
                        <h3 className="card-title">{t("Plano de ferias no corrente ano")}</h3>

                        {!loading ? (
                          <ResponsiveContainer width="100%" height={300}>
                            <BarChart
                              data={feriasMensal}
                              margin={{ top: 5, right: 5, left: 5, bottom: 5 }}
                            >
                              <CartesianGrid />
                              <XAxis dataKey="mes" />
                              <YAxis allowDecimals={false} />
                              <Tooltip />
                              <Legend />
                              <Bar
                                dataKey="total"
                                name="Férias"
                                fill="#0a0a5e"
                              />
                            </BarChart>
                          </ResponsiveContainer>
                        ) : (
                          <div>Carregando...</div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row mt-4">{/* <MapChart /> */}</div>
          </div>
        </div>

        <ToastContainer />
      </div>
    );
};

export default AdminDashboard;
